
import Vue from 'vue';
import AsHeadline from '@/components/Ui/AsHeadline.vue';
import { isSafari } from '../../util/browser';
import { isSafariDesktop } from '../../util/browser';

export default Vue.extend({
  name: 'AppContent',
  components: {
    AsHeadline,
    LoadingSpinner: () => import('@/components/Spinners/LoadingSpinner.vue'),
  },
  props: {
    title: String,
    name: String,
    busy: Boolean,
  },
  computed: {
    safari() {
      return isSafari && !isSafariDesktop;
    },
    safariDesktop() {
      return isSafariDesktop;
    },
  },
  watch: {
    title: {
      immediate: true,

      handler() {
        const domain = location.hostname.split('.');
        try {
          if (!1 == domain[1].startsWith('consents') || domain[2].endsWith('consents')) {
            document.title = this.title + ' - AccountScore';
          } else {
            document.title = this.title + ' - consents.online';
          }
        } catch (a) {
          document.title = this.title + ' - consents.online';
        }
      },
    },
  },
});
